// @flow
export const STATUS = {
  S_DRAFT: 0,
  S_WAITING: 10,
  S_PUBLISHED: 20,
  S_UNAPPROVED: 30,
};
